module.exports = __webpack_public_path__ + "mail.png?81c78a50e272038741dad3fc893d34a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mail.png
// module id = 106
// module chunks = 0